import React from "react";
import { Translate } from "orion-components/i18n";

const Selector = () => {
	return (
		<div>
			<h1>
				<Translate value="global.sharedComponents.statusCard.statusControls.selector" />
			</h1>
		</div>
	);
};

export default Selector;
